<template>
  <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
    <path
      fill="currentColor"
      d="M12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2Z"
    />
  </svg>
</template>
